import React from "react";
import { MEDIA_QUERIES, theme, Text } from "@ifgengineering/component-library";
import Icon from "@icon-park/react/es/all";
import { investmentOptions } from "./consts";
import { useMediaQuery } from "react-responsive";
import { Chips } from "./Chips";
import TrustBox from "../../TrustBox";
import {
  BodyWrapper,
  HeaderContainer,
  InvestInContainer,
  PromoTwoWrapper,
  FlexContainer,
} from "./styled";
import { TrustBoxWrapper } from "../../TrustBox/styled";

export const PromoTwoHeader: React.FC = () => {
  return (
    <HeaderContainer>
      <Text type="T24" color="GOLD500" fontFamily="archiaregular">
        Join the club and unlock access to institutional-grade, high-yield
        investments with low entry minimums.
      </Text>
      <FlexContainer>
        <Icon type="PeopleSafe" fill={theme.colors.SUCCESS300} size={24} />
        <Text type="P16" color="SLATE300">
          All funds are vetted for sharia compliance
        </Text>
      </FlexContainer>
    </HeaderContainer>
  );
};

export const PromoTwoBody: React.FC = () => {
  const isTabPort = useMediaQuery({ query: MEDIA_QUERIES.TAB_PORT });

  const investChipBgColor =
    "linear-gradient(268.87deg,rgb(192, 232, 190) 0%, #F2FBFC 100%)";

  return (
    <BodyWrapper>
      <InvestInContainer>
        <Text type="H14" color="SLATE200">
          Invest in
        </Text>
        <Chips
          items={investmentOptions}
          bgColor={investChipBgColor}
          textColor="GREEN800"
        />
      </InvestInContainer>
      {/*{!isTabPort && <TrustBox />}*/}
    </BodyWrapper>
  );
};

const PromoTwo: React.FC = () => {
  const isTabPort = useMediaQuery({ query: MEDIA_QUERIES.TAB_PORT });

  return (
    <PromoTwoWrapper>
      <PromoTwoHeader />
      <TrustBoxWrapper>{isTabPort && <TrustBox />}</TrustBoxWrapper>
      {!isTabPort && <PromoTwoBody />}
    </PromoTwoWrapper>
  );
};

export default PromoTwo;
